export const OfficeDashboardState = {
	url: '/dashboard',
	title: 'Office Dashboard',
	template: '<dashboard-page></dashboard-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeDashboardPageMod" */
			'@Containers/office-dashboard-page/office-dashboard-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
